@if (loginalertcontent | async; as alertmessage) {
  <div>
    @if (isAlertVisible) {
      <div [ngClass]="isUserLoggedIn ? 'alertloginbox' : 'alertbox'" id="alertlogin">
        <div class="collapse alerttext show col-md-10 col-10 float_left" [innerHTML]="alertmessage.content"></div>
        <button type="button" class="alertclose col-md-1 col-1 float_left" aria-label="Close" (click)="closeAlert()">
          <span aria-hidden="true">x</span>
        </button>
      </div>
    }
  </div>
}
